import dayjs from "dayjs";
import { number, object, string } from "yup";

import {
  AccountType,
  BankAccount,
  CompanyType,
  PlatformAccount,
} from "@/interfaces/talk2pay.iterfaces";
import { T2PayHomeMessages } from "@/messages/platforms/talk2PayHome/t2pay-home.messages";

export const buildInitialData = (platformAccountInfo: PlatformAccount | null): PlatformAccount => {
  return {
    object: platformAccountInfo?.object || "",
    id: platformAccountInfo?.id || "",
    name: platformAccountInfo?.name || "",
    email: platformAccountInfo?.email || "",
    loginEmail: platformAccountInfo?.loginEmail || "",
    mobilePhone: platformAccountInfo?.mobilePhone || "",
    address: platformAccountInfo?.address || "",
    addressNumber: platformAccountInfo?.addressNumber || "",
    complement: platformAccountInfo?.complement || "",
    province: platformAccountInfo?.province || "",
    postalCode: platformAccountInfo?.postalCode || "",
    cpfCnpj: platformAccountInfo?.cpfCnpj || "",
    personType: platformAccountInfo?.personType || "JURIDICA",
    companyType: platformAccountInfo?.companyType || CompanyType.MEI,
    city: platformAccountInfo?.city || 0,
    state: platformAccountInfo?.state || "",
    country: platformAccountInfo?.country || "Brasil",
    walletId: platformAccountInfo?.walletId || "",
    apiKey: platformAccountInfo?.apiKey || "",
    accountNumber: {
      agency: platformAccountInfo?.accountNumber?.agency || "",
      account: platformAccountInfo?.accountNumber?.account || "",
      accountDigit: platformAccountInfo?.accountNumber?.accountDigit || "",
    },
    incomeValue: platformAccountInfo?.incomeValue || 0.0,
    incomeRange: platformAccountInfo?.incomeRange || "UP_TO_50K",
  };
};

export function translateCompanyType(
  companyType: CompanyType,
  messages: T2PayHomeMessages
): { value: string; label: string } {
  switch (companyType) {
    case CompanyType.MEI:
      return { value: companyType, label: messages.companyTypeMEILabel };
    case CompanyType.LIMITED:
      return { value: companyType, label: messages.companyTypeLimitedLabel };
    case CompanyType.INDIVIDUAL:
      return { value: companyType, label: messages.companyTypeIndividualLabel };
    default:
      return { value: companyType, label: "" };
  }
}

export const buildBankAccountInitialData = (): BankAccount => {
  const currentDate = dayjs().format("YYYY-MM-DDTHH:mm:ss");
  return {
    id: "",
    rowDate: currentDate,
    platformId: 0,
    bankCode: null,
    bankName: "",
    agency: "",
    agencyDigit: null,
    number: "",
    digit: null,
    name: "",
    type: AccountType.CORRENTE,
  };
};

export const buildBankAccountFormSchema = (messages: T2PayHomeMessages) =>
  object().shape({
    bankCode: number().required(messages.bankCodeError),
    bankName: string().required(messages.bankNameError),
    agency: string().required(messages.agencyError),
    agencyDigit: string().nullable(),
    number: string().required(messages.accountNumberError),
    digit: string().required(messages.accountDigitError),
    name: string().required(messages.accountNameError),
    type: string().required(messages.accountTypeError),
  });
